import 'styled-components';
import { tokens, type Tokens } from './tokens.js';

/** The styled-components theme is just the ported token set. */
export const theme = tokens;
export type AppTheme = Tokens;

declare module 'styled-components' {
  // eslint-disable-next-line @typescript-eslint/no-empty-object-type
  export interface DefaultTheme extends AppTheme {}
}
